<template>
    <form class="card">
        <h3>Информация</h3>
        <div v-if="status == ''">
            <div class="form-item">
                <label for="parking_phone">Телефон парковки</label>
                <input type="text" id="parking_phone" class="text-input" v-model="data.contact_phone" />
            </div>
            <div class="separator"></div>

            <div class="inline">
                <div class="grid">
                    <strong>Организация:</strong>
                    <div class="form-item">
                        <label for="cuit">CUIT</label>
                        <input type="text" id="cuit" class="text-input" v-model="data.cuit" />
                    </div>

                    <div class="form-item">
                        <label for="orgname">Имя или название организации</label>
                        <input type="text" id="orgname" class="text-input" v-model="data.org_name" />
                    </div>
                    <div class="form-item">
                        <label for="postaddress">Почтовый адрес</label>
                        <input type="text" id="postaddress" class="text-input" v-model="data.org_address" />
                    </div>
                    <!--<div class="form-item">
                        <label for="email">Email в системе Mercado Pago</label>
                        <input type="text" id="email" class="text-input" v-model="data.mercado_email" />
                    </div>-->
                </div>
                <div class="grid">
                    <strong>Контактное лицо:</strong>
                    <div class="form-item">
                        <label for="fullname">Имя Фамилия</label>
                        <input type="text" id="fullname" class="text-input" v-model="data.org_contact" />
                    </div>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
    export default {
        props: ['status', 'data'],
        created () {
            this.$emit('getData')
        }
    }
</script>